<template>
  <div class="brief-introduction-wrapper">
    <img class="u-cute-lab-img" :src="source('brief-bg')" alt="">
    <div class="problem-text" ref="titleRef">WHAT IS THE U-CUTE LAB?</div>
    <div class="answer-text" ref="textRef">
      An interdisciplinary and multi-integrated young team with multi-dimensional interactive space global design and development capabilities
    </div>

    <img class="space-icon" :src="commonSource('space')" alt="">
    <gear-cute class="gear-cute-wrapper" rotate width="15vw" height="15vw"/>

    <div class="problem-list-wrapper" ref="listRef">
      <div>WHO WE ARE</div>
      <div>Spatial Narrative</div>
      <div>Operation strategy</div>
      <div>Technology as Media</div>
      <div>Experience Upgrade</div>
    </div>
    <div  @click="toPage('/who-we-are')" class="view-more-wrapper" :style="{
      'background-image': `url(${source('brief-view-more')})`
    }">
      <div class="img_box">
        <img :src="source('brief-view-more-right')" alt="VIEW MORE">
      </div>
    </div>
  </div>
</template>

<script>
import GearCute from "@/components/gear-cute.vue";
import key from "@/api/key";

export default {
  name: 'brief-introduction',
  components: { GearCute },
  data() {
    return {
      animationList: [
        [{ transform: 'translateX(100vw)' }, { transform: 'translateX(0)' }],
        [{ transform: 'translateX(-100vw)' }, { transform: 'translateX(0)' }],
        { duration: 2000, fill: 'forwards', easing: 'ease' }
      ]
    }
  },
  methods: {
    source(name) {
      return key.getByName(key.HOME, name).fileUrl
    },
    commonSource(name) {
      return key.getByName(key.COMMON, name).fileUrl
    },
    obsAnimation(el, fun, isUnobserve = false) {
      const ob = new IntersectionObserver(e => {
        if (!e[0].isIntersecting) return
        fun(el)
        if (isUnobserve) ob.unobserve(el)
      })
      ob.observe(el)
    },
    titleAnimation() {
      this.obsAnimation(this.$refs.titleRef, (el) => {
        el.className = 'problem-text animate__animated animate__fadeInUp'
      })
    },
    mainTextAnimation() {
      this.obsAnimation(this.$refs.textRef, (el) => {
        el.className = 'answer-text animate__animated animate__fadeInLeft'
      })
    },
    listAnimation() {
      this.obsAnimation(this.$refs.listRef, (el) => {
        for (let i = 0; i < el.children.length; i++) {
          el.children[i].animate(this.animationList[[0, 2, 4].includes(i) ? 0 : 1], this.animationList[2])
        }
      }, true)
    }
  },
  mounted() {
    this.titleAnimation()
    this.mainTextAnimation()
    this.listAnimation()
  }
}
</script>

<style scoped lang="scss">
.brief-introduction-wrapper {
  position: relative;
  width: 100vw;
  height: 102.292vw;
  background-color: #191919;

  .u-cute-lab-img {
    width: 100%;
    height: 100%;
  }

  .problem-text {
    position: absolute;
    top: 6.042vw;
    left: 3.646vw;
    width: 36.198vw;
    height: 10.521vw;
    font-size: 5vw;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 5vw;
  }

  .answer-text {
    position: absolute;
    top: 18.542vw;
    left: 3.646vw;
    width: 39.271vw;
    height: 10.104vw;
    font-size: 2.083vw;
    color: #FFFFFF;
    line-height: 2.5vw;
  }

  .space-icon {
    position: absolute;
    top: 18.542vw;
    right: 6.198vw;
    width: 35.15625vw;
    height: 16.146vw;
  }

  .gear-cute-wrapper {
    position: absolute;
    top: 29.323vw;
    right: 35.625vw;
  }

  .problem-list-wrapper {
    position: absolute;
    top: 52.083vw;
    height: 4.115vw;
    font-size: 4.583vw;
    font-weight: 900;
    color: #FFFFFF;
    line-height: 4.115vw;
    transition: all 1s;

    :nth-child(1) {
      margin-left: 43.437vw;
      font-size: 3.333vw;
      transition: all 1s;
    }

    :nth-child(2) {
      margin-top: 1.72vw;
      margin-left: 36.542vw;
      transition: all 1s;
    }

    :nth-child(3) {
      margin-top: 1.72vw;
      margin-left: 23.781vw;
      transition: all 1s;
    }

    :nth-child(4) {
      margin-top: 1.72vw;
      margin-left: 35.687vw;
      transition: all 1s;
    }

    :nth-child(5) {
      margin-top: 1.72vw;
      margin-left: 30.083vw;
      transition: all 1s;
    }
  }

  .view-more-wrapper {
    position: absolute;
    bottom: 10.46875vw;
    left: 38.021vw;
    width: 20.729vw;
    height: 7.03125vw;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    text-align: right;
    .img_box {
      width: 100%;
      height: 100%;
      position: relative;
      img {
        position: absolute;
        top: 2.8vw;
        width: 4vw;
        height: 4vw;
        right: .7vw;
        animation: rotate .8s linear infinite;
      }
    }
    &:hover {
      cursor: pointer;
    }
  }
}
@keyframes rotate {
  0%, 100% {
    transform: translateX(-0.5vw);
  }
  50% {
    transform: translateX(0.5vw);
  }
}
@keyframes rotate-left {
  0% {
    transform: translate(100vw, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}

@keyframes rotate-right {
  0% {
    transform: translate(-100vw, 0);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
